<script setup lang="ts">
import logoUrl from '@/assets/logo.svg'

withDefaults(
  defineProps<{

    height?: number
  }>(),
  { height: 44 },
)
</script>

<template>
  <img
    :src="logoUrl"
    alt="LYLUP"
    class="brand-logo"
    :style="{ height: `${height}px`, width: 'auto' }"
  />
</template>

<style scoped>
.brand-logo {
  display: block;
  object-fit: contain;
}
</style>
